/**
 * Imagem que a página publica no portal.
 *
 * É uma só para toda a página — não uma por pergunta, canal ou política — e pode
 * ser ocultada sem perder o arquivo. Quem edita é a prévia da própria listagem.
 */
export interface ImagemPagina {
  exibirImagem: boolean;
  /** Caminho do arquivo publicado ou base64 do recorte que ainda não foi salvo. */
  imagem: string;
  nomeImagem: string;
  arquivo: File | null;
}

/** Recorte e limite de upload da imagem, iguais nas três páginas. */
export const IMAGEM_PAGINA = {
  largura: 800,
  altura: 450,
  tamanhoMaximoMb: 10
};

export const TIPOS_IMAGEM_PAGINA = ['image/png', 'image/jpeg'];

export function imagemPaginaVazia(): ImagemPagina {
  return { exibirImagem: false, imagem: '', nomeImagem: '', arquivo: null };
}

export function revogarImagemPagina(imagem: ImagemPagina): void {
  if (imagem.imagem.startsWith('blob:')) {
    URL.revokeObjectURL(imagem.imagem);
  }
}

export function mesmaImagem(uma: ImagemPagina, outra: ImagemPagina): boolean {
  return uma.exibirImagem === outra.exibirImagem
    && uma.imagem === outra.imagem
    && uma.nomeImagem === outra.nomeImagem;
}
